import React, { useState, useRef } from 'react';
import { getMonthlyStatement } from '../../service/SpatApi';
import { convertTimestampToDate, areDatesEqual, formatDateDDMMYYYY, formatINR } from "../../utils/Utilities";
import { printHtmlContent } from "../../utils/printTemplate";
import { useSelector } from "react-redux";
import '../general/General.css';
const MonthlyStatement = () => {
  const user = useSelector((state) => state.user);
  const [filters, setFilters] = useState({
    from: '',
    to: '',
    forReporting: false
  });

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [creditAmount, setcreditAmount] = useState(0);
  const [debitAmount, setdebitAmount] = useState(0);
  const [netAmount, setnetAmount] = useState(0);
  const [creditAmountInLastStatement, setcreditAmountInLastStatement] = useState(0);
  const [debitAmountInLastStatement, setdebitAmountInLastStatement] = useState(0);
  const [netAmountInLastStatement, setnetAmountInLastStatement] = useState(0);
  const [lastStatementDate, setlastStatementDate] = useState('');
  const tableRef = useRef();

  // Handle input changes, clear changes
  const handleInput = e => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const runQuery = async () => {
    const { from, to } = filters;

    if (!from || !to) {
      setError('தயவுசெய்து தொடக்கம் மற்றும் முடிவு தேதிகளை உள்ளிடவும்.');
      return;
    }

    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (fromDate > toDate) {
      setError('"தொடக்கம் தேதி" முடிவு தேதிக்குப் பிறகு இருக்க முடியாது.');
      return;
    }

    const diffInDays = (toDate - fromDate) / (1000 * 60 * 60 * 24);
    if (diffInDays > 92) {
      setError('தேதி வரம்பு 3 மாதங்களை மீறக்கூடாது.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const queryParams = {
        from,
        to,
        ...(filters.forReporting && { forReporting: 'true' })  // backend expects string
      };

      const resp = await getMonthlyStatement(queryParams);

      // Sort transactions by transactionDate ascending

      const sortedTransactions = (resp.transactions || []).sort((a, b) => {
        // Convert transactionDate to JS Date safely
        const dateA = a.transactionDate.toDate ? a.transactionDate.toDate() : new Date(a.transactionDate._seconds * 1000);
        const dateB = b.transactionDate.toDate ? b.transactionDate.toDate() : new Date(b.transactionDate._seconds * 1000);

        return dateA.getTime() - dateB.getTime(); // ascending order
      });


      setTransactions(sortedTransactions);
      setcreditAmount(resp.creditAmount);
      setdebitAmount(resp.debitAmount);
      setnetAmount(resp.netAmount);
      setcreditAmountInLastStatement(resp.creditAmountInLastStatement);
      setdebitAmountInLastStatement(resp.debitAmountInLastStatement);
      setnetAmountInLastStatement(resp.netAmountInLastStatement);
      setlastStatementDate(resp.lastStatementDate);
    } catch (err) {
      console.error(err);
      setError('மாதாந்திர அறிக்கையை ஏற்ற முடியவில்லை.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    if (!tableRef.current) return;
    const fromFormatted = formatDateDDMMYYYY(filters.from);
    const toFormatted = formatDateDDMMYYYY(filters.to);
    printHtmlContent(tableRef.current.innerHTML, {
      title: 'மாதாந்திர அறிக்கை',
      header: 'மாதாந்திர அறிக்கை',
      footer: '',
      statementTitle: fromFormatted + ' முதல் ' + toFormatted + ' வரை'
    });
  };

  return (
    <>
      <h2>மாதாந்திர கணக்கு</h2>
      <br />

      <div className="auth_element">
        <label className="auth_label">
          தேதி முதல்:
          <input
            className="auth_input"
            name="from"
            type="date"
            value={filters.from}
            onChange={handleInput}
          />
        </label>

        <label className="auth_label">
          தேதி வரை:
          <input
            className="auth_input"
            name="to"
            type="date"
            value={filters.to}
            onChange={handleInput}
          />
        </label>
        {user?.roles?.includes('SuperUser') && (
          <label className="auth_label" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              name="forReporting"
              checked={filters.forReporting}
              onChange={(e) =>
                setFilters(prev => ({ ...prev, forReporting: e.target.checked }))
              }
              style={{ marginRight: '0.5rem' }}
            />
            அறிக்கையாக உருவாக்கவும் (lock செய்யவும்)
          </label>

        )}


        <button className="auth_button" onClick={runQuery} disabled={loading}>
          {loading ? 'ஏற்றுகிறது…' : 'அறிக்கையை பெறவும்'}
        </button>

        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>

      {transactions.length > 0 ? (
        <>
          {user?.roles?.includes('SuperUser') && (
            <button onClick={handlePrint} style={{ margin: '1rem 0' }}>
              🖨️  அச்சிடு
            </button>
          )}
          <div className="table-container" ref={tableRef}>
            <table className="table">
              <thead>
                <tr>
                  <th >தேதி</th>
                  <th>விவரங்கள்</th>
                  <th>வரவு</th>
                  <th>செலவு</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((d, index) => {
                  const effectiveDateStr = convertTimestampToDate(d.effectiveDate).toLocaleDateString();
                  const transactionDateStr = convertTimestampToDate(d.transactionDate).toLocaleDateString();

                  // Description content
                  let description = `${d.categoryDescription}-${d.subCategoryDescription || ''}`;

                  const datesDiffer = !areDatesEqual(
                    convertTimestampToDate(d.transactionDate),
                    convertTimestampToDate(d.effectiveDate)
                  );
                  if (datesDiffer) {
                    description += ` (கணக்கு தேதி: ${effectiveDateStr})`;
                  }
                  if (d.externalTransactionReference) {
                    description += ` குறிப்பு:${d.externalTransactionReference}`;
                  }
                  if (d.familyId || d.familyMemberFirstName) {
                    description += ` குடும்பம்: ${d.familyId || '-'} / ${d.familyMemberFirstName || '-'}`;
                  }

                  // Receipt details (cash / online)
                  if (d.receiptNo) {
                    description +=` ரசீது எண்: ${d.receiptNo}`;
                  } 
                  return (
                    <tr key={index}>
                      <td style={{ width: '40px', whiteSpace: 'nowrap' }}>{transactionDateStr}</td>
                      <td>{description}</td>
                      <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{d.transactionType === 'credit' ? ` ${formatINR(d.amount)}` : ''}</td>
                      <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{d.transactionType === 'debit' ? ` ${formatINR(d.amount)}` : ''}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td colSpan={1} style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    {`மொத்த வரவு:`}
                  </td>
                  <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    {formatINR(creditAmount)}

                  </td>
                  
                </tr>
                <tr>
                  <td></td>
                  <td colSpan={1} style={{ textAlign: 'right' }}>

                    {`மொத்த செலவு:`}

                  </td>
                  
                  <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    {formatINR(debitAmount)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td colSpan={1} style={{ textAlign: 'right' }}>
                    {`இருப்பு :`}
                  </td>
                  <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    {formatINR(netAmount + netAmountInLastStatement)}
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}></td>
                </tr>

                <tr >
                  <td>கடந்த அறிக்கை விவரங்கள்</td>
                  <td colSpan={3}>
                    {`தேதி: ` + formatDateDDMMYYYY(convertTimestampToDate(lastStatementDate))}
                    <br />
                    {`மொத்த வரவு: ` + formatINR(creditAmountInLastStatement)}
                    <br />
                    {`மொத்த செலவு: ` + formatINR(debitAmountInLastStatement)}
                    <br />
                    {`இருப்பு: ` + formatINR(netAmountInLastStatement)}
                  </td>
                </tr>


              </tbody>

            </table>
          </div>
        </>
      ) : (
        !loading && <p>கொடுக்கப்பட்ட தேதிக்கான பதிவுகள் இல்லை.</p>
      )}
    </>
  );
};

export default MonthlyStatement;
